
import React from 'react';
import { isSameDay, format } from 'date-fns';
import { Calendar } from '@/components/ui/calendar';
import { CalendarEvent } from '@/hooks/use-chart-data';
import { getProductColor } from '@/utils/colorUtils';

interface HarvestMonthCalendarProps {
  currentMonth: Date;
  monthEvents: CalendarEvent[];
}

export const HarvestMonthCalendar: React.FC<HarvestMonthCalendarProps> = ({ 
  currentMonth, 
  monthEvents 
}) => {
  const renderDateContent = (day: Date) => {
    const dayEvents = monthEvents.filter(event => isSameDay(new Date(event.date), day));
    
    return (
      <div className="relative h-full w-full">
        <div className="text-center">{format(day, 'd')}</div>
        {dayEvents.length > 0 && (
          <div className="absolute bottom-0 left-0 right-0 flex justify-center gap-1 overflow-hidden">
            {dayEvents.map((event, index) => (
              <div 
                key={`${event.id}-${index}`}
                className="w-2 h-2 rounded-full"
                style={{ backgroundColor: getProductColor(event.product) }}
                title={`${event.product}: ${event.quantity}kg - ${event.farmName}`}
              />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <Calendar
      mode="single"
      selected={new Date()}
      month={currentMonth}
      className="rounded-md border p-3 pointer-events-auto"
      components={{
        Day: ({ date, ...props }) => (
          <div
            className={`relative flex h-9 w-9 items-center justify-center rounded-md text-sm`}
            {...props}
          >
            {renderDateContent(date)}
          </div>
        ),
      }}
    />
  );
};
